
import { defineMessages } from 'react-intl';
const defaultMessages = defineMessages(
  {
    "onboardingAddBrandColor": {
      "id": "onboarding.add_brand_color",
      "defaultMessage": "Add Color",
    },
    "onboardingBrandColor": {
      "id": "onboarding.brand_color",
      "defaultMessage": "Color",
    },
    "onboardingComplete": {
      "id": "onboarding.complete",
      "defaultMessage": "Complete"
    },
    "onboardingCompleted": {
      "id": "onboarding.completed",
      "defaultMessage": "Completed"
    },
    "onboardingContent": {
      "id": "onboarding.content",
      "defaultMessage": "Content"
    },
    "onboardingContentAbout": {
      "id": "onboarding.content_about",
      "defaultMessage": "About Us"
    },
    "onboardingContentBlog": {
      "id": "onboarding.content_blog",
      "defaultMessage": "Blog"
    },
    "onboardingContentCatering": {
      "id": "onboarding.content_catering",
      "defaultMessage": "Catering"
    },
    "onboardingContentContactUs": {
      "id": "onboarding.content_contact_us",
      "defaultMessage": "Contact Us"
    },
    "onboardingContentEventsCalendar": {
      "id": "onboarding.content_events_calendar",
      "defaultMessage": "Events"
    },
    "onboardingContentExternalOrdering": {
      "id": "onboarding.content_external_ordering",
      "defaultMessage": "External Ordering & Delivery Services"
    },
    "onboardingContentGiftCard": {
      "id": "onboarding.content_gift_card",
      "defaultMessage": "Digital Gift Cards"
    },
    "onboardingContentHiring": {
      "id": "onboarding.content_hiring",
      "defaultMessage": "Hiring"
    },
    "onboardingContentLiveBeerList": {
      "id": "onboarding.content_live_beer_list",
      "defaultMessage": "Live Beer List"
    },
    "onboardingContentOlo": {
      "id": "onboarding.content_olo",
      "defaultMessage": "Online Ordering"
    },
    "onboardingContentOnlineStore": {
      "id": "onboarding.content_online_store",
      "defaultMessage": "Online Store"
    },
    "onboardingContentPhotoGallery": {
      "id": "onboarding.content_photo_gallery",
      "defaultMessage": "Photo Gallery"
    },
    "onboardingContentPressPage": {
      "id": "onboarding.content_press_page",
      "defaultMessage": "Press"
    },
    "onboardingContentPrivateEvent": {
      "id": "onboarding.content_private_event",
      "defaultMessage": "Private Events"
    },
    "onboardingContentPromotions": {
      "id": "onboarding.content_promotions",
      "defaultMessage": "Promotions"
    },
    "onboardingContentReservation": {
      "id": "onboarding.content_reservation",
      "defaultMessage": "Reservations"
    },
    "onboardingDomain": {
      "id": "onboarding.domain",
      "defaultMessage": "Domain"
    },
    "onboardingDomainTitle": {
      "id": "onboarding.domain_title",
      "defaultMessage": "Domain Support"
    },
    "onboardingEditMenu": {
      "id": "onboarding.edit_menu",
      "defaultMessage": "Edit Menu"
    },
    "onboardingEditFile": {
      "id": "onboarding.edit_file",
      "defaultMessage": "Edit File"
    },
    "onboardingFileName": {
      "id": "onboarding.file_name",
      "defaultMessage": "File Name"
    },
    "onboardingFileNameTooltip": {
      "id": "onboarding.file_name_tooltip",
      "defaultMessage": "Edit File Name"
    },
    "onboardingFontSaved": {
      "id": "onboarding.font_saved",
      "defaultMessage": "Fonts saved!"
    },
    "onboardingIsOloMenu": {
      "id": "onboarding.is_olo_menu",
      "defaultMessage": "Available for Popmenu Ordering",
    },
    "onboardingLinkPlaceholder": {
      "id": "onboarding.link_placeholder",
      "defaultMessage": "Type or paste URL"
    },
    "onboardingLogo": {
      "id": "onboarding.logo",
      "defaultMessage": "Logo"
    },
    "onboardingMenu": {
      "id": "onboarding.menus",
      "defaultMessage": "Menus"
    },
    "onboardingMenuSaved": {
      "id": "onboarding.menu_saved",
      "defaultMessage": "Menu saved!"
    },
    "onboardingMenuCategoryName": {
      "id": "onboarding.menu_category_name",
      "defaultMessage": "Type of Menu"
    },
    "onboardingModalStyleSummary": {
      "id": "onboarding.modal_style",
      "defaultMessage": "Site Styles"
    },
    "onboardingModalContent": {
      "id": "onboarding.modal_content",
      "defaultMessage": "Site Content"
    },
    "onboardingModalMenu": {
      "id": "onboarding.modal_menu",
      "defaultMessage": "Menus"
    },
    "onboardingMonday": {
      "id": "onboarding.monday",
      "defaultMessage": "Monday Integration"
    },
    "onboardingNotePlaceholder": {
      "id": "onboarding.note_placeholder",
      "defaultMessage": "Please add any special notes or requests about your file(s)."
    },
    "onboardingNote": {
      "id": "onboarding.note",
      "defaultMessage": "Note"
    },
    "onboardingNoteSaved": {
      "id": "onboarding.note_saved",
      "defaultMessage": "Note saved!"
    },
    "onboardingNoteSent": {
      "id": "onboarding.note_sent",
      "defaultMessage": "Note sent!"
    },
    "onboardingNotStarted": {
      "id": "onboarding.not_started",
      "defaultMessage": "Not Started",
    },
    "onboardingPending": {
      "id": "onboarding.pending",
      "defaultMessage": "Pending",
    },
    "onboardingPhotos": {
      "id": "onboarding.photos",
      "defaultMessage": "Photos"
    },
    "onboardingGoals": {
      "id": "onboarding.goals",
      "defaultMessage": "Goals"
    },
    "onboardingBusinessGoals": {
      "id": "onboarding.business_goals",
      "defaultMessage": "Business Goals"
    },
    "onboardingNoBusinessGoalsSelected": {
      "id": "onboarding.no_business_goals_selected",
      "defaultMessage": "No Businnes Goals Selected"
    },
    "onboardingRestaurant": {
      "id": "onboarding.restaurant",
      "defaultMessage": "Restaurant"
    },
    "onboardingStatus": {
      "id": "onboarding.status",
      "defaultMessage": "Status"
    },
    "onboardingSend": {
      "id": "onboarding.send",
      "defaultMessage": "Send"
    },
    "onboardingSettings": {
      "id": "onboarding.settings",
      "defaultMessage": "Onboarding Settings"
    },
    "onboardingStarted": {
      "id": "onboarding.started",
      "defaultMessage": "Started"
    },
    "onboardingSave": {
      "id": "onboarding.save",
      "defaultMessage": "Save"
    },
    "onboardingSaveFont": {
      "id": "onboarding.save_font",
      "defaultMessage": "Save Font"
    },
    "onboardingSaveNote": {
      "id": "onboarding.save_note",
      "defaultMessage": "Save Note"
    },
    "onboardingRequestNewImport": {
      "id": "onboarding.request_new_import",
      "defaultMessage": "Request New Import"
    },
    "onboardingStepContent": {
      "id": "onboarding.step_content",
      "defaultMessage": "Choose Site Content"
    },
    "onboardingStepDomain": {
      "id": "onboarding.step_domain",
      "defaultMessage": "Domain Setup"
    },
    "onboardingStepInfo": {
      "id": "onboarding.step_info",
      "defaultMessage": "Add Restaurant Info"
    },
    "onboardingStepInfoLocationTitle": {
      "id": "onboarding.step_info_location_title",
      "defaultMessage": "Location Info"
    },
    "onboardingStepInfoRestaurantTitle": {
      "id": "onboarding.step_info_restaurant_title",
      "defaultMessage": "Restaurant Info"
    },
    "onboardingStepLogo": {
      "id": "onboarding.step_logo",
      "defaultMessage": "Upload Logo"
    },
    "onboardingStepMenu": {
      "id": "onboarding.step_menu",
      "defaultMessage": "Add Menu"
    },
    "onboardingStepPhoto": {
      "id": "onboarding.step_photo",
      "defaultMessage": "Upload Photos"
    },
    "onboardingStepStyle": {
      "id": "onboarding.step_style",
      "defaultMessage": "Discover Site Styles"
    },
    "onboardingStyles": {
      "id": "onboarding.styles",
      "defaultMessage": "Styles"
    },
    "onboardingStyleNotePlaceholder": {
      "id": "onboarding.style_note_placeholder",
      "defaultMessage": "Please add any special notes or requests about your site styles."
    },
    "onboardingSummary": {
      "id": "onboarding.summary",
      "defaultMessage": "Summary"
    },
    "onboardingTabsGoogleFontsTab": {
      "id": "onboarding.tabs.google_fonts_tab",
      "defaultMessage": "Google Fonts"
    },
    "onboardingTabsImportTab": {
      "id": "onboarding.tabs.import_tab",
      "defaultMessage": "Imports"
    },
    "onboardingTabsUploadTab": {
      "id": "onboarding.tabs.upload_tab",
      "defaultMessage": "Files"
    },
    "onboardingTabsNoteTab": {
      "id": "onboarding.tabs.note_tab",
      "defaultMessage": "Note"
    },
    "onboardingTabsSummaryTab": {
      "id": "onboarding.tabs.summary_tab",
      "defaultMessage": "Summary"
    },
    "onboardingTabsUrlTab": {
      "id": "onboarding.tabs.links_tab",
      "defaultMessage": "Links"
    },
    "onboardingBusinessGoalsStepOption1": {
      "id": "onboarding.step.business_goals_opt_1",
      "defaultMessage": "A better looking website"
    },
    "onboardingBusinessGoalsStepOption2": {
      "id": "onboarding.step.business_goals_opt_2",
      "defaultMessage": "Increasing dine-in orders"
    },
    "onboardingBusinessGoalsStepOption3": {
      "id": "onboarding.step.business_goals_opt_3",
      "defaultMessage": "Increasing online orders"
    },
    "onboardingBusinessGoalsStepOption4": {
      "id": "onboarding.step.business_goals_opt_4",
      "defaultMessage": "Consolidating technology solutions"
    },
    "onboardingBusinessGoalsStepOption5": {
      "id": "onboarding.step.business_goals_opt_5",
      "defaultMessage": "Using technology to make up for a shortage of staff"
    },
    "onboardingBusinessGoalsStepOption6": {
      "id": "onboarding.step.business_goals_opt_6",
      "defaultMessage": "Gaining more followers"
    },
    "onboardingBusinessGoalsStepOption7": {
      "id": "onboarding.step.business_goals_opt_7",
      "defaultMessage": "Start taking reservations"
    },
    "onboardingBusinessGoalsStepOption8": {
      "id": "onboarding.step.business_goals_opt_8",
      "defaultMessage": "Other"
    },
  }
);
export default defaultMessages;
